import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Button = styled(Link)`
  display: inline-block;
  padding: 14px 28px;
  font-size: 1.1rem;
  border-radius: 999px;
  background: #ff761a;
  color: #ffffff;
  font-family: 'Lobster', cursive;
  transition: transform 0.05s ease, opacity 0.2s ease;
  text-align: center;
  &:hover { opacity: 0.95; }
  &:active { transform: translateY(1px); }
`;

const MenuButton = () => (
  <Button to="/menu">View Menu</Button>
);

export default MenuButton;
